import downloadjs from "downloadjs";
import * as moment from "moment";
import * as React from "react";
import Datetime from "react-datetime";
import { Base } from "ui/Scripts/source/framework/base";
import { SaveDataObj } from "../../framework/saveData";
import { customHistory } from "../../framework/customHistory";
import * as store from "../../framework/customStore";
import * as storeTypes from "../../models/store/storeTypes";
import * as eventService from "../../models/services/eventService";
import * as storeActions from "../../models/store/storeActions";
import * as attachmentService from "../../models/services/attachmentService";
import { EventEditItem, IEventEditItem } from "../../models/event/eventEditItem";
import { EventHandler, IEventHandler } from "../../models/event/eventHandler";
import { Session } from "../../models/session/session";
import { Translations } from "ui/Scripts/source/models/translations";
import { AttachmentList } from "../attachment/attachmentList";
import { CameraPhoto } from "../framework/cameraPhoto";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { EventHandlerList } from "./eventHandlerList";
import { EventMessageList } from "./eventMessageList";
import { EventEventTypeList } from "./eventEventTypeList";
import { IEventEventType, EventEventType, EventTypeCategory } from "../../models/event/eventEventType";
import { IEndlessList, EndlessList } from "ui/Scripts/source/models/common/endlessList";
import { SaveEventMessage } from "../../models/event/saveEventMessage";
import { SaveEventHandler } from "../../models/event/saveEventHandler";
import { SaveEventEventType } from "../../models/event/saveEventEventType";
import { IEventMessage, EventMessage } from "../../models/event/eventMessage";
import { IEventCompany, } from "../../models/event/eventCompany";
import { RouteComponentProps } from "react-router";
import { SelectUnitDialog } from "./selectUnitDialog";
import { SelectReceiverDialog } from "./selectReceiverDialog";
import { EditPageHeader } from "../app/header";
import { IUnitItem, UnitItem } from "../../models/unit/unitItem";
import { IUnlockResult } from "../../models/common/unlockResult";
import { EventTypeNode, IEventTypeNode } from "../../models/event/eventTypeNode";
import { SelectEventTypesDialog } from "./selectEventTypesDialog";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { ConfirmationDialogResult, EventAttachmentCategory } from "ui/Scripts/source/models/enums";
import { IUserListItem } from "../../models/user/userListItem";
import { AppUtils } from "../../framework/appUtils";
import { SaveAttachmentBase64 } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { EventEditBasicInformationSummary } from "./eventEditBasicInformationSummary";
import { EventEditActionsSummary } from "./eventEditActionsSummary";
import { EventEditIdentificationSummary } from "./eventEditIdentificationSummary";
import { EventEditEventHandlersSummary } from "./eventEditEventHandlersSummary";
import { SelectUrgencyClassDialog } from "./selectUrgencyClassDialog";
import { EventEditUrgencyClassStateText } from "ui/Scripts/source/components/event/eventEditUrgencyClassStateText";
import { Footer } from "../app/footer";
import { IEventSettingSimple } from "ui/Scripts/source/models/eventSettings/eventSettingSimple";
import { FormRow } from "../framework/formRow";
import { FormGroup } from "../framework/formGroup";
import { LockedToOtherUser } from "../locking/lockedToOtherUser";

//EventEdit
export interface IEventEditOwnProps {
}

export interface IEventEditStateProps {
    item: IEventEditItem;
    createCompany: IEventCompany;
    companies: IEventCompany[];
    units: IUnitItem[];
    urgencyClasses: IIdColorTitle[];
    eventSetting: IEventSettingSimple;
    eventTypeNodes: IEventTypeNode[];
    eventTypeBNodes: IEventTypeNode[];
    eventTypeCNodes: IEventTypeNode[];
    attachments: IFileAttachment[];
    userCompanyId: string;
    userCode: string;
    userName: string;
    userPicture: string;
    canHandleEvent: boolean;
    canRemoveEvent: boolean;
    canSaveEvent: boolean;
    canEditIdentificationData: boolean;
    userIsIsSystemAdmin: boolean;
    returnUrl: string;
}

export interface IEventEditDispatchProps {
    loadEvent: (id: string) => void;
    resetEvent: () => void;
    refreshEventLock: (id: string) => void;
}

export interface IEventEditPathProps {
    eventId: string;
}

type EventEditProp = IEventEditOwnProps & IEventEditStateProps & IEventEditDispatchProps & RouteComponentProps<IEventEditPathProps>;

/* eslint-disable no-unused-vars */
const enum NewEventWizardWindowType {
    Receiver = "0",
    EventType = "1",
    EventTypeB = "2",
    EventTypeC = "3"
}
/* eslint-enable no-unused-vars */

interface IEventEditState {
    id: string;
    rowId: string;
    userIsIsSystemAdmin: boolean;
    canHandleEvent: boolean;
    canEditIdentificationData: boolean;
    eventSetting: IEventSettingSimple;
    latitude: number;
    longitude: number;
    locationName: string;
    positionErrorCode: number;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    //Phase 1: Receiver (USED ONLY IN NEW MODE)
    companyId: string;
    //Phase 2: Basic information
    createCompanyId: string;
    unitId: string;
    unitCode: string;
    createCompanyUnitId: string;
    createCompanyUnitCode: string;
    urgencyClassId: string;
    code: string;
    date: string;
    time: string;
    name: string;
    observer: string;
    observerAction: string;
    description: string;
    newEventWizardWindows: NewEventWizardWindowType[];
    newEventWizardWindowIndex: number;
    showSelectReceiverDialog: boolean;
    showSelectUnitDialog: boolean;
    showSelectUrgencyClassDialog: boolean;
    showSelectEventTypeDialog: boolean;
    showSelectEventTypeBDialog: boolean;
    showSelectEventTypeCDialog: boolean;
    //Phase 2: Attachments
    attachments: IFileAttachment[];
    photoAttachmentIds: string[];
    removedAttachmentIds: string[];
    cameraIds: string[];
    showCamera: boolean;
    showingCamera: boolean;
    cameraEventAttachmentCategory: number;
    //Phase 3: Actions
    actionsVisible: boolean;
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    //Phase 4: Identification
    identificationVisible: boolean;
    eventEventTypes: IEventEventType[];
    savedEventEventTypeIds: string[];
    removedEventEventTypeIds: string[];
    removedEventEventTypeBIds: string[];
    removedEventEventTypeCIds: string[];
    directCosts: string;
    indirectCosts: string;
    amount: string;
    identificationDetails: string;
    //Phase 5: Followup
    eventHandlersVisible: boolean;
    eventHandlers: IEventHandler[];
    savedEventHandlerIds: string[];
    removedEventHandlerIds: string[];
    //Phase 5: Comment (USED ONLY IN NEW MODE)
    comment: string;
    //Phase 6: Read only view of phases 1-5
    //Phase 7: Messages (USED ONLY IN EDIT MODE)
    messagesVisible: boolean;
    eventMessages: IEventMessage[];
    //Phase 8: Summary full
}
    
interface INewEventWizardWindows {
    windows: NewEventWizardWindowType[];
    index: number;
}

export class EventEdit extends React.Component<EventEditProp, IEventEditState> {
    private static orgStateHash = "";
    private static hashIgnoreSaveDataFields = ["id", "rowId"];

    private dataContainerDiv: HTMLDivElement;
    private scrollToTop: boolean;
    private companyLogo: string;
    private scrollToClassName: string;

    private static getEventMessages = (eventEditItem: IEventEditItem): IEventMessage[] => {
        const result = eventEditItem.eventMessages.slice(0);
        //Published
        if (!Base.isNullOrUndefined(eventEditItem.publishDate)) {
            const publishedEventMessage = new EventMessage();
            publishedEventMessage.id = Base.getGuid();
            publishedEventMessage.modifyDate = eventEditItem.publishDate;
            publishedEventMessage.publishIndicator = true;
            result.push(publishedEventMessage);
        }
        //Approved
        let closed = true;
        let lastApprovedEventHandler: EventHandler = null;
        for (let i = 0; i < eventEditItem.eventHandlers.length; i++) {
            const eventHandler = eventEditItem.eventHandlers[i];
            if (Base.isNullOrUndefined(eventHandler.approveDate)) {
                closed = false;
                continue;
            }
            const approvedEventMessage = new EventMessage();
            approvedEventMessage.id = Base.getGuid();
            approvedEventMessage.modifyUserCode = eventHandler.userCode;
            approvedEventMessage.name = eventHandler.userName;
            approvedEventMessage.picture = eventHandler.userPicture;
            approvedEventMessage.modifyDate = eventHandler.approveDate;
            approvedEventMessage.approveIndicator = true;
            result.push(approvedEventMessage);
            if (closed && (Base.isNullOrUndefined(lastApprovedEventHandler) || lastApprovedEventHandler.approveDate < eventHandler.approveDate)) {
                lastApprovedEventHandler = eventHandler;
            }
        }
        //Closed
        if (closed && !Base.isNullOrUndefined(lastApprovedEventHandler)) {
            const closedEventMessage = new EventMessage();
            closedEventMessage.id = Base.getGuid();
            closedEventMessage.modifyDate = lastApprovedEventHandler.approveDate + 1;
            closedEventMessage.closedIndicator = true;
            result.push(closedEventMessage);
        }
        result.sort((a: EventMessage, b: EventMessage) => {
            return b.modifyDate - a.modifyDate;
        });
        return result;
    };

    private static validateEventBasicInformation = (state: IEventEditState): boolean => {
        if (!state.date) {
            AppUtils.showErrorMessage(Translations.DateMustBeDefined);
            return false;
        }
        if (!state.time) {
            AppUtils.showErrorMessage(Translations.TimeMustBeDefined);
            return false;
        }
        if (!state.name) {
            AppUtils.showErrorMessage(Translations.TitleMustBeDefined);
            return false;
        }
        if (!state.description) {
            AppUtils.showErrorMessage(Translations.DescriptionMustBeDefined);
            return false;
        }
        if (state.eventSetting?.observerActionIsRequired() && !state.observerAction) {
            AppUtils.showErrorMessage(Translations.ObserverActionMustBeDefined);
            return false;
        }
        return true;
    };

    private static getSaveDataFromState = async (props: EventEditProp, state: IEventEditState, saveAll: boolean, validate: boolean): Promise<SaveDataObj> => {
        const data = new SaveDataObj();
        //General
        data.append("id", state.id);
        data.append("publish", true);
        data.append("rowId", state.rowId);
        //Location
        if (EventEdit.isNewEventStatic(props)) {
            data.append("latitude", !Base.isNullOrUndefined(state.latitude) ? state.latitude : null);
            data.append("longitude", !Base.isNullOrUndefined(state.longitude) ? state.longitude : null);
            data.append("locationName", !state.locationName ? null : state.locationName);
        }
        //Phase 1: Receiver
        data.append("companyId", state.companyId);
        //Phase 3: Basic information, Attachments
        data.append("unitId", state.unitId);
        data.append("urgencyClassId", state.urgencyClassId);
        data.append("createCompanyUnitId", state.createCompanyUnitId);
        data.append("name", state.name);
        data.append("date", Base.getDateTime(state.date, state.time).getTime());
        data.append("observer", state.observer);
        data.append("observerAction", state.observerAction);
        data.append("description", state.description);
        const attachments: SaveAttachmentBase64[] = [];
        for (const fileAttachment of state.attachments.filter(i => !!i.file)) {
            const attachment = await SaveAttachmentBase64.fromFileAttachment(state.photoAttachmentIds.indexOf(fileAttachment.id) > -1 ? "photo" : "", fileAttachment);
            if (!attachment) continue;
            attachments.push(attachment);
        }
        data.append("attachments", attachments);
        data.append("removeAttachmentIds", state.removedAttachmentIds);
        if (saveAll) {
            //Validate
            if (validate && !EventEdit.validateEventBasicInformation(state)) return null;
            //Phase 4: Comment (USED ONLY IN NEW MODE)
            if (EventEdit.isNewEventStatic(props) && !Base.isNullOrEmpty(state.comment)) {
                data.append("eventMessages", [SaveEventMessage.createSaveEventMessage(state.comment)]);
            }
            //Phase 5: Actions
            data.append("immediateAction", state.immediateAction);
            data.append("preventiveAction", state.preventiveAction);
            data.append("rootCause", state.rootCause);
        }
        //Handlers
        data.append("eventHandlers", state.eventHandlers.reduce((result, i) => {
            if (state.savedEventHandlerIds.indexOf(i.id) >= 0) {
                result.push(new SaveEventHandler(i));
            }
            return result;
        }, []));
        data.append("removeEventHandlerIds", state.removedEventHandlerIds);
        //Phase 6: Comments
        //Phase 7: Identification
        data.append("eventEventTypes", state.eventEventTypes.reduce((result, i) => {
            if (state.savedEventEventTypeIds.indexOf(i.id) >= 0) {
                result.push(new SaveEventEventType(i));
            }
            return result;
        }, []));
        data.append("removeEventEventTypeIds", state.removedEventEventTypeIds);
        data.append("removeEventEventTypeBIds", state.removedEventEventTypeBIds);
        data.append("removeEventEventTypeCIds", state.removedEventEventTypeCIds);
        data.append("directCosts", state.directCosts.toDecimal(false, true));
        data.append("indirectCosts", state.indirectCosts.toDecimal(false, true));
        data.append("amount", state.amount.toDecimal(false, true));
        data.append("identificationDetails", state.identificationDetails);
        return data;
    };

    private static getNewEventWizardWindows(props: EventEditProp): INewEventWizardWindows {
        const result: INewEventWizardWindows = {
            windows: [],
            index: -1
        };
        const isNewEvent = props.match.params.eventId === Base.emptyGuid;
        if (!isNewEvent) return result;
        if (props.companies.length > 1 || props.units.length > 1) {
            result.windows.push(NewEventWizardWindowType.Receiver);
        }
        if (EventTypeNode.getSelectableEventTypeNodes(props.eventTypeNodes).length > 0) {
            result.windows.push(NewEventWizardWindowType.EventType);
        }
        if (EventTypeNode.getSelectableEventTypeNodes(props.eventTypeBNodes).length > 0) {
            result.windows.push(NewEventWizardWindowType.EventTypeB);
        }
        if (EventTypeNode.getSelectableEventTypeNodes(props.eventTypeCNodes).length > 0) {
            result.windows.push(NewEventWizardWindowType.EventTypeC);
        }
        if (result.windows.length > 0) {
            result.index = 0;
        }
        return result;
    }

    private static getStateFromProps = (props: EventEditProp, cameraIds: string[]): IEventEditState => {
        const isNewEvent = props.match.params.eventId === Base.emptyGuid;
        let item = props.item;
        if (Base.isNullOrUndefined(props.item)) {
            item = new EventEditItem();
        }
        const newEventWizardWindows = EventEdit.getNewEventWizardWindows(props);
        const result = {
            scrollToTop: false,
            id: item.id,
            rowId: item.rowId,
            canHandleEvent: props.canHandleEvent,
            canEditIdentificationData: props.canEditIdentificationData,
            userIsIsSystemAdmin: props.userIsIsSystemAdmin,
            eventSetting: props.eventSetting,
            //location
            positionErrorCode: isNewEvent ? -1 : 0,
            latitude: item.latitude,
            longitude: item.longitude,
            locationName: item.locationName,
            lockedDate: item.lockedDate,
            lockedUserCode: item.lockedUserCode,
            lockedUserName: item.lockedUserName,
            lockedUserPicture: item.lockedUserPicture,
            //Phase 1: Receiver (USED ONLY IN NEW MODE)
            createCompanyId: item.createCompanyId,
            companyId: item.companyId,
            //Phase 2: Basic information
            unitId: item.unitId,
            unitCode: Base.nullToEmpty(item.unitCode),
            createCompanyUnitId: item.createCompanyUnitId,
            createCompanyUnitCode: Base.nullToEmpty(item.createCompanyUnitCode),
            urgencyClassId: item.urgencyClassId,
            code: Base.nullToEmpty(item.code),
            date: Base.timeToDateStr(item.date),
            time: Base.timeToTimeStr(item.date),
            name: Base.nullToEmpty(item.name),
            observer: Base.nullToEmpty(item.observer),
            observerAction: Base.nullToEmpty(item.observerAction),
            description: Base.nullToEmpty(item.description),
            newEventWizardWindows: newEventWizardWindows.windows.slice(0),
            newEventWizardWindowIndex: newEventWizardWindows.index,
            showSelectReceiverDialog: false,
            showSelectUnitDialog: false,
            showSelectUrgencyClassDialog: false,
            showSelectEventTypeDialog: false,
            showSelectEventTypeBDialog: false,
            showSelectEventTypeCDialog: false,
            //Phase 2: Attachments
            attachments: props.attachments,
            photoAttachmentIds: [],
            removedAttachmentIds: [],
            cameraIds,
            showCamera: false,
            showingCamera: false,
            cameraEventAttachmentCategory: EventAttachmentCategory.Basic,
            //Phase 3: Actions
            actionsVisible: false,
            immediateAction: Base.nullToEmpty(item.immediateAction),
            preventiveAction: Base.nullToEmpty(item.preventiveAction),
            rootCause: Base.nullToEmpty(item.rootCause),
            //Phase 4: Identification
            identificationVisible: false,
            eventEventTypes: item.eventTypes.slice(0),
            savedEventEventTypeIds: [],
            removedEventEventTypeIds: [],
            removedEventEventTypeBIds: [],
            removedEventEventTypeCIds: [],
            directCosts: item.directCosts.toLocaleFixed(2),
            indirectCosts: item.indirectCosts.toLocaleFixed(2),
            amount: item.amount.toLocaleFixed(2),
            identificationDetails: item.identificationDetails,
            //Phase 5: Followup
            eventHandlersVisible: false,
            eventHandlers: EventHandler.sortEventHandlers(item.eventHandlers, { currentUserCode: props.userCode }),
            savedEventHandlerIds: item.isNew() ? item.eventHandlers.map(i => i.id) : [],
            removedEventHandlerIds: [],
            //Phase 5: Comment (USED ONLY IN NEW MODE)
            comment: "",
            //Phase 6: Read only view of phases 1-5
            //Phase 7: Messages (USED ONLY IN EDIT MODE)
            messagesVisible: false,
            eventMessages: EventEdit.getEventMessages(item),
            //Phase 8: Summary full
        };
        if (!Base.isNullOrEmpty(result.id)) {
            EventEdit.getSaveDataFromState(props, result, true, false)
                .then(saveData => {
                    EventEdit.orgStateHash = saveData.getHash(EventEdit.hashIgnoreSaveDataFields);
                });
            //Send read receipt for event
            const userIsCreator = item.createUserCode === props.userCode;
            if (!userIsCreator && !item.isRead && item.isPublished()) {
                AppUtils.callService(() => eventService.sendEventReadReceipt(item.id), false, true);
            }
        } else {
            EventEdit.orgStateHash = "";
        }
        return result;
    };

    constructor(props: EventEditProp) {
        super(props);
        this.scrollToClassName = null;
        this.state = EventEdit.getStateFromProps(props, []);
    }

    static getDerivedStateFromProps(nextProps: EventEditProp, prevState: IEventEditState): IEventEditState {
        if (Base.isNullOrUndefined(prevState.id) || (!Base.isNullOrUndefined(nextProps.item) && nextProps.item.id !== prevState.id)) {
            return EventEdit.getStateFromProps(nextProps, prevState.cameraIds.slice(0));
        } else {
            return null;
        }
    }

    private scrollToRowElement = () => {
        //console.log("scrollToRowElement", this.scrollToClassName);
        if (!Base.isNullOrEmpty(this.scrollToClassName)) {
            if (this.dataContainerDiv.scrollTo !== null && this.dataContainerDiv.scrollTo !== undefined) {
                const elements = this.dataContainerDiv.getElementsByClassName(this.scrollToClassName);
                if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                    const y = (elements[0] as HTMLDivElement).offsetTop;
                    this.dataContainerDiv.scrollTo({
                        top: y,
                        left: 0,
                        behavior: "auto"
                    });
                }
            }
            this.scrollToClassName = null;
        }
    };

    componentDidMount(): void {
        const obj = this;
        Base.getCameraIds().then(ids => {
            obj.setState({ cameraIds: ids });
        }).catch(() => {
            obj.setState({ cameraIds: [] });
        });
        this.props.loadEvent(this.props.match.params.eventId);
        //Set companyLogo
        Session.getCompanyLogo().then((companyLogo) => {
            obj.companyLogo = companyLogo;
        });
    }

    componentDidUpdate(prevProps: EventEditProp, prevState: IEventEditState, snapshot: any): void {
        //Scroll to element
        if (this.scrollToTop) {
            if (!this.dataContainerDiv.scrollTo) {
                this.dataContainerDiv.scrollTop = 0;
                this.dataContainerDiv.scrollLeft = 0;
            } else {
                this.dataContainerDiv.scrollTo(0, 0);
            }
            this.scrollToTop = false;
        } else {
            //Scroll to attachments after closing camera
            this.scrollToRowElement();
        }
        //Set location for new event if location is in use
        const props = this.props;
        const prevEventId = prevProps.match.params.eventId;
        const eventId = props.match.params.eventId;
        const prevLocationIsInUse = prevProps.eventSetting?.locationIsInUse() ?? false;
        const locationIsInUse = props.eventSetting?.locationIsInUse() ?? false;
        if (prevEventId !== eventId || prevLocationIsInUse !== locationIsInUse) {
            if (!locationIsInUse || eventId !== Base.emptyGuid) return;
            setTimeout(() => {
                Base.getLocationAsync(appConfig.googleApiKey)
                    .then(result => {
                        this.setState({
                            latitude: result.latitude,
                            longitude: result.longitude,
                            locationName: result.locationName,
                            positionErrorCode: result.positionErrorCode
                        });
                    });
            }, 200);
        }
    }

    componentWillUnmount(): void {
        this.props.resetEvent();
    }

    private static isNewEventStatic = (props: EventEditProp): boolean => {
        return props.match.params.eventId === Base.emptyGuid;
    };
        
    isNewEvent = (): boolean => {
        return EventEdit.isNewEventStatic(this.props);
    };

    canHandleEvent = (): boolean => {
        return this.state.canHandleEvent && this.props.userCompanyId === this.state.companyId;
    };

    canEditIdentificationData = (): boolean => {
        return this.state.canEditIdentificationData;
    };

    userIsCreator = (): boolean => {
        return this.props.userCode.toLowerCase() === this.props.item.createUserCode.toLowerCase();
    };
    
    //Locking
    //#region Locking
    isLocked = (): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0;
    };

    isLockedToUser = (userCode: string): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0 && !Base.isNullOrEmpty(state.lockedUserCode) && userCode.equalIgnoreCase(state.lockedUserCode);
    };

    isLockedToOtherUser = (userCode: string): boolean => {
        const state = this.state;
        return !Base.isNullOrUndefined(state.lockedDate) && state.lockedDate > 0 && !Base.isNullOrEmpty(state.lockedUserCode) && !userCode.equalIgnoreCase(state.lockedUserCode);
    };

    unlockEvent = async (id: string, lockToCurrentUser: boolean, afterUnlock: (result: IUnlockResult) => void) => {
        const result = await AppUtils.callService(() => eventService.unlock(id, lockToCurrentUser));
        if (!result) return null;
        store.customStore.dispatch(storeActions.eventListSetLocked(id, false));
        if (afterUnlock) {
            afterUnlock(result);
        }
    };

    closeView = (unlock: boolean): void => {
        const props = this.props;
        if (unlock !== null || unlock !== undefined) {
            if (unlock) {
                this.unlockEvent(props.item.id, false, () => {
                    customHistory.push("/event");
                });
            } else {
                customHistory.push("/event");
            }
        }
    };

    handleUnlockClick = async () => {
        const props = this.props;
        const state = this.state;
        const result = await AppUtils.showConfirmationDialog(String.format(Translations.DoYouReallyWantToUnlockEvent, props.item.name));
        if (result !== ConfirmationDialogResult.Yes) return;
        this.unlockEvent(props.item.id, true, (result: IUnlockResult) => {
            this.setState({
                lockedUserCode: result.lockedUserCode ? result.lockedUserCode : state.lockedUserCode,
                lockedUserName: result.lockedUserCode ? props.userName : state.lockedUserCode,
                lockedUserPicture: result.lockedUserCode ? props.userPicture : state.lockedUserPicture,
                lockedDate: result.lockedDate ? result.lockedDate : state.lockedDate,
            });
        });
    };
    //#endregion Locking

    saveEvent = async (saveAll: boolean): Promise<void> => {
        const obj = this;
        const props = this.props;
        const isLockedToOtherUser = obj.isLockedToOtherUser(props.userCode);
        if (isLockedToOtherUser) {
            AppUtils.showErrorMessage(String.format(Translations.LockedEventParameterCannotBeSaved, props.item.name));
            return;
        }
        const unlockOnClose = obj.isLockedToUser(props.userCode) && !props.item.isNew();
        const saveData = await EventEdit.getSaveDataFromState(props, this.state, saveAll, true);
        if (Base.isNullOrUndefined(saveData)) return;
        saveData.append("changed", EventEdit.orgStateHash !== saveData.getHash(EventEdit.hashIgnoreSaveDataFields));
        //Call server
        const result = await AppUtils.callService(() => eventService.saveEvent(saveData.obj));
        if (!result) return;
        if (!Base.isNullOrEmpty(result.notifications)) {
            store.customStore.dispatch(storeActions.showInfoMessage(Translations.CreatingNotifications));
            const emailResult = await AppUtils.callService(() => eventService.emailEvent(result.id, result.notifications));
            store.customStore.dispatch(storeActions.clearInfoMessage());
            if (!emailResult) return;
        }
        obj.closeView(unlockOnClose);
    };

    handleSaveClick = async () => {
        if (!EventEdit.validateEventBasicInformation(this.state)) return;
        const firstApproveAndClosedDate = this.props.item.getFirstAndLastEventHandlerApproveDate();
        const isClosed = !Base.isNullOrUndefined(firstApproveAndClosedDate.closedDate);
        const result = await AppUtils.showConfirmationDialog(Translations.SaveEventHandlerConfirmation, false, storeTypes.ConfirmationDialogType.Information, Translations.SaveEvent);
        if (result === ConfirmationDialogResult.Yes) {
            this.saveEvent(!isClosed && (this.isNewEvent() || this.canHandleEvent()));
        }
    };

    handleBackClick = async () => {
        const props = this.props;
        const unlockOnClose = !this.isLockedToOtherUser(props.userCode) && this.isLockedToUser(props.userCode) && !props.item.isNew();
        const cancelResult = await AppUtils.cancel((await EventEdit.getSaveDataFromState(this.props, this.state, true, false)).getHash(EventEdit.hashIgnoreSaveDataFields), EventEdit.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            const firstApproveAndClosedDate = props.item.getFirstAndLastEventHandlerApproveDate();
            const isClosed = !Base.isNullOrUndefined(firstApproveAndClosedDate.closedDate);
            this.saveEvent(!isClosed && (this.isNewEvent() || this.canHandleEvent()));
        } else {
            this.closeView(unlockOnClose);
        }
    };

    //#region Phase 1 (USED ONLY IN NEW MODE)
    setStateAfterSelectReceiverForNewEvent = async (companyId: string, unitId: string, newEventWizardWindowIndex: number, showSelectReceiverDialog: boolean) => {
        const obj = this;
        const props = this.props;
        const state = this.state;
        if (Base.isNullOrEmpty(companyId)) return;
        const index = props.companies.findIndex(i => i.id === companyId);
        if (Base.isNullOrUndefined(index) || index < 0) return;
        //Company or unit has not been changed: proceed to next phase
        if (state.companyId === companyId && (index !== 0 || state.unitId === unitId)) {
            this.setState({
                showSelectReceiverDialog,
                //Wizard dialog next step
                newEventWizardWindowIndex
            });
            return;
        }
        //Company or unit has been changed: set default event handlers and proceed to next phase
        const result = await AppUtils.callService(() => eventService.getEventDefaultHandlers(companyId, unitId, true));
        if (!result) return;
        const eventHandlers: EventHandler[] = [];
        for (let i = 0; i < result.items.length; i++) {
            const eventHandler = new EventHandler();
            eventHandler.id = Base.getGuid();
            eventHandler.userCode = result.items[i].code;
            eventHandler.userName = result.items[i].name;
            eventHandler.userPicture = result.items[i].picture;
            eventHandlers.push(eventHandler);
        }
        if (index === 0) {
            //Set event handlers
            obj.setState({
                showSelectReceiverDialog,
                companyId,
                unitId: result.unitId,
                unitCode: result.unitCode,
                createCompanyUnitId: result.createCompanyUnitId,
                createCompanyUnitCode: result.createCompanyUnitCode,
                eventSetting: result.eventSetting,
                //Phase 5: Followup
                eventHandlers: EventHandler.sortEventHandlers(eventHandlers, { currentUserCode: props.userCode }),
                savedEventHandlerIds: eventHandlers.map(j => j.id),
                removedEventHandlerIds: [],
                canHandleEvent: result.canHandleEvent,
                canEditIdentificationData: result.canEditIdentificationData,
                //Wizard dialog next step
                newEventWizardWindowIndex
            });
        } else {
            //Reset all values except basic information and attachments
            obj.setState({
                showSelectReceiverDialog,
                companyId,
                unitId: result.unitId,
                unitCode: result.unitCode,
                createCompanyUnitId: result.createCompanyUnitId,
                createCompanyUnitCode: result.createCompanyUnitCode,
                eventSetting: result.eventSetting,
                //Phase 2: Attachments
                //attachments: [],
                //photoAttachmentIds: [],
                //removedAttachmentIds: [],
                //showCamera: false,
                //Phase 3: Actions
                immediateAction: "",
                preventiveAction: "",
                rootCause: "",
                //Phase 4: Identification
                directCosts: (0 as number).toLocaleFixed(2),
                indirectCosts: (0 as number).toLocaleFixed(2),
                amount: (0 as number).toLocaleFixed(2),
                identificationDetails: "",
                //Phase 5: Followup
                eventHandlers: EventHandler.sortEventHandlers(eventHandlers, { currentUserCode: props.userCode }),
                savedEventHandlerIds: eventHandlers.map(j => j.id),
                removedEventHandlerIds: [],
                canHandleEvent: result.canHandleEvent,
                canEditIdentificationData: result.canEditIdentificationData,
                //Wizard dialog next step
                newEventWizardWindowIndex
            });
        }
    };

    //Wizard windows
    handleSelectReceiverWizardDialogNext = (companyId: string, unitId: string) => {
        const state = this.state;
        const newEventWizardWindowIndex = state.newEventWizardWindowIndex + 1;
        this.setStateAfterSelectReceiverForNewEvent(companyId, unitId, state.newEventWizardWindows.length > newEventWizardWindowIndex ? newEventWizardWindowIndex : -1, state.showSelectReceiverDialog);
    };

    getStateAfterSelectEventTypeForNewEvent = (ids: string[], eventTypeCategory: number): { eventEventTypes: IEventEventType[], savedEventEventTypeIds: string[]} => {
        const state = this.state;
        //Add event type
        const eventEventTypes = state.eventEventTypes.filter(i => i.eventTypeCategory !== eventTypeCategory);
        const savedEventEventTypeIds = eventEventTypes.map(i => i.id);
        if (ids && ids.length) {
            for (let i = 0; i < ids.length; i++) {
                const eventEventType = EventEventType.createEventEventType(ids[i], eventTypeCategory);
                eventEventTypes.push(eventEventType);
                savedEventEventTypeIds.push(eventEventType.id);
            }
        }
        return {
            eventEventTypes,
            savedEventEventTypeIds
        };
    };

    handleSelectEventTypeWizardDialogNext = (ids: string[], eventTypeCategory: number) => {
        const state = this.state;
        const newEventWizardWindowIndex = state.newEventWizardWindowIndex + 1 < state.newEventWizardWindows.length ? state.newEventWizardWindowIndex + 1 : -1;
        //Set state
        const newState = this.getStateAfterSelectEventTypeForNewEvent(ids, eventTypeCategory);
        this.setState({ ...newState, newEventWizardWindowIndex });
    };

    handleSelectEventTypeWizardDialogPrevious = () => {
        this.setState({
            newEventWizardWindowIndex: this.state.newEventWizardWindowIndex - 1,
        });
    };

    handleSelectEventTypeWizardDialogCancel = () => {
        this.setState({
            newEventWizardWindowIndex: -1,
        });
    };

    //Manually change receiver
    handleSelectReceiverClick = () => {
        this.setState({
            showSelectReceiverDialog: true,
        });
    };

    handleSelectReceiverDialogOk = (companyId: string, unitId: string) => {
        this.setStateAfterSelectReceiverForNewEvent(companyId, unitId, this.state.newEventWizardWindowIndex, false);
    };

    handleSelectReceiverDialogCancel = () => {
        this.setState({
            showSelectReceiverDialog: false
        });
    };

    //Manually change urgency class
    handleChangeUrgencyClassClick = () => {
        this.setState({
            showSelectUrgencyClassDialog: true
        });
    };

    handleSelectUrgencyClassDialogOk = (urgencyClassId: string) => {
        this.setState({ urgencyClassId, showSelectUrgencyClassDialog: false });
    };

    handleSelectUrgencyClassDialogCancel = () => {
        this.setState({
            showSelectUrgencyClassDialog: false
        });
    };

    //Manually change event type
    handleChangeNewEventTypeClick = () => {
        this.setState({
            showSelectEventTypeDialog: true
        });
    };

    handleSelectEventTypeDialogOk = (ids: string[]) => {
        const newState = this.getStateAfterSelectEventTypeForNewEvent(ids, EventTypeCategory.A);
        this.setState({ ...newState, showSelectEventTypeDialog: false });
    };

    handleSelectEventTypeDialogCancel = () => {
        this.setState({
            showSelectEventTypeDialog: false,
        });
    };

    //Manually change event type B
    handleChangeNewEventTypeBClick = () => {
        this.setState({
            showSelectEventTypeBDialog: true
        });
    };

    handleSelectEventTypeBDialogOk = (ids: string[]) => {
        const newState = this.getStateAfterSelectEventTypeForNewEvent(ids, EventTypeCategory.B);
        this.setState({ ...newState, showSelectEventTypeBDialog: false });
    };

    handleSelectEventTypeBDialogCancel = () => {
        this.setState({
            showSelectEventTypeBDialog: false
        });
    };

    //Manually change event type C
    handleChangeNewEventTypeCClick = () => {
        this.setState({
            showSelectEventTypeCDialog: true,
        });
    };

    handleSelectEventTypeCDialogOk = (ids: string[]) => {
        const newState = this.getStateAfterSelectEventTypeForNewEvent(ids, EventTypeCategory.C);
        this.setState({ ...newState, showSelectEventTypeCDialog: false });
    };

    handleSelectEventTypeCDialogCancel = () => {
        this.setState({
            showSelectEventTypeCDialog: false,
        });
    };
    //#endregion

    //#region Phase 2: Basic information, Phase 3: Actions, Phase 4: Identification
    handleSelectUnitClick = () => {
        this.setState({ showSelectUnitDialog: true });
    };

    handleLoadUnits = (page: number): Promise<IEndlessList<IUnitItem>> => {
        const obj = this;
        return new Promise<IEndlessList<IUnitItem>>((resolve, reject) => {
            const result = new EndlessList<IUnitItem>(null, UnitItem);
            result.items = obj.props.units.slice(0);
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    getSelectableEventTypeNodes = (): IEventTypeNode[] => {
        return EventTypeNode.getSelectableEventTypeNodes(this.props.eventTypeNodes);
    };

    getSelectableEventTypeBNodes = (): IEventTypeNode[] => {
        return EventTypeNode.getSelectableEventTypeNodes(this.props.eventTypeBNodes);
    };

    getSelectableEventTypeCNodes = (): IEventTypeNode[] => {
        return EventTypeNode.getSelectableEventTypeNodes(this.props.eventTypeCNodes);
    };

    handleSelectUnitDialogOk = async (id: string, code: string) => {
        const obj = this;
        //New unit not selected
        if (Base.isNullOrEmpty(id)) {
            this.setState({
                showSelectUnitDialog: false
            });
            return;
        }
        //Company unit
        const userCompanyIsReceivingCompany = this.props.userCompanyId === this.state.companyId;
        if (userCompanyIsReceivingCompany) {
            //Unit has not been changed
            if (this.state.unitId === id) {
                this.setState({
                    showSelectUnitDialog: false
                });
                return;
            }
            const userCompanyIsSendingCompany = this.props.userCompanyId === this.state.createCompanyId;
            //Unit has been changed: set default event handlers
            const result = await AppUtils.callService(() => eventService.getEventDefaultHandlers(this.state.companyId, id, false));
            if (!result) return;
            const eventHandlers = obj.state.eventHandlers.slice(0);
            const savedEventHandlerIds = this.state.savedEventHandlerIds.slice(0);
            for (let i = 0; i < result.items.length; i++) {
                const userCode = result.items[i].code;
                if (eventHandlers.findIndex(j => j.userCode === userCode) >= 0) continue;
                const eventHandler = new EventHandler();
                eventHandler.id = Base.getGuid();
                eventHandler.userCode = userCode;
                eventHandler.userName = result.items[i].name;
                eventHandler.userPicture = result.items[i].picture;
                eventHandlers.push(eventHandler);
                savedEventHandlerIds.push(eventHandler.id);
            }
            //Set unit and event handlers
            obj.setState({
                unitId: result.unitId,
                unitCode: result.unitCode,
                createCompanyUnitId: userCompanyIsSendingCompany ? result.unitId : this.state.createCompanyUnitId,
                createCompanyUnitCode: userCompanyIsSendingCompany ? result.unitCode : this.state.createCompanyUnitCode,
                showSelectUnitDialog: false,
                //Phase 5: Followup
                eventHandlers: EventHandler.sortEventHandlers(eventHandlers, { currentUserCode: this.props.userCode }),
                savedEventHandlerIds,
                canHandleEvent: result.canHandleEvent,
                canEditIdentificationData: result.canEditIdentificationData
            });
        } else {
            //CreateCompany unit
            if (this.props.userCompanyId !== this.state.companyId) {
                if (this.state.createCompanyUnitId === id) {
                    this.setState({ showSelectUnitDialog: false });
                } else {
                    obj.setState({
                        createCompanyUnitId: id,
                        createCompanyUnitCode: code,
                        showSelectUnitDialog: false,
                    });
                }
            }
        }
    };

    handleSelectUnitDialogCancel = () => {
        this.setState({
            showSelectUnitDialog: false
        });
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "name") {
            this.setState({ name: value });
        } else if (name === "observer") {
            this.setState({ observer: value });
        } else if (name === "observerAction") {
            this.setState({ observerAction: value });
        } else if (name === "description") {
            this.setState({ description: value });
        } else if (name === "immediateAction") {
            this.setState({ immediateAction: value });
        } else if (name === "preventiveAction") {
            this.setState({ preventiveAction: value });
        } else if (name === "rootCause") {
            this.setState({ rootCause: value });
        } else if (name === "identificationDetails") {
            this.setState({ identificationDetails: value });
        } else if (name === "comment") {
            this.setState({ comment: value });
        } else if (name === "directCosts") {
            this.setState({ directCosts: value });
        } else if (name === "indirectCosts") {
            this.setState({ indirectCosts: value });
        } else if (name === "amount") {
            this.setState({ amount: value });
        }
    };

    handleBlur = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        const decimalValue = value.toDecimal(false, true);
        if (name === "directCosts") {
            this.setState({ directCosts: decimalValue.toLocaleFixed(2) });
        } else if (name === "indirectCosts") {
            this.setState({ indirectCosts: decimalValue.toLocaleFixed(2) });
        } else if (name === "amount") {
            this.setState({ amount: decimalValue.toLocaleFixed(2) });
        }
    };

    handleDateChange = (value: moment.Moment | string) => {
        if (typeof value !== "string") {
            this.setState({ date: Base.timeToDateStr(value) });
        }
    };

    handleDateBlur = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            this.setState({ date: Base.timeToDateStr(value.toDate().getTime()) });
        } else {
            this.setState({ date: Base.timeToDateStr(value) });
        }
    };

    handleTimeChange = (value: moment.Moment | string) => {
        if (typeof value !== "string") {
            this.setState({ time: Base.timeToTimeStr(Base.roundTimeMinutes(Base.timeToTimeStr(value).toTime().getTime(), 5)) });
        }
    };

    handleTimeBlur = (value: moment.Moment | string) => {
        if (typeof value === "string") {
            this.setState({ time: Base.timeToTimeStr(Base.roundTimeMinutes(value.toTime().getTime(), 5)) });
        } else {
            this.setState({ time: Base.timeToTimeStr(Base.roundTimeMinutes(Base.timeToTimeStr(value).toTime().getTime(), 5)) });
        }
    };
    //#endregion

    //#region Phase 2: Attachments
    handleAttachmentAdd = (fileList: FileList, category: number) => {
        FileAttachment.addFileListToFileAttachments(this.state.attachments, fileList, category).then(attachments => {
            this.setState({ attachments });
        });
    };

    handleAttachmentDownload = async (id: string) => {
        if (Base.isNullOrEmpty(id)) return;
        const attachment = this.state.attachments.find(i => i.id === id);
        if (Base.isNullOrUndefined(attachment)) return;
        if (!Base.isNullOrUndefined(attachment.file)) {
            downloadjs(attachment.file, attachment.name); //, "image/jpeg"
            return;
        }
        if (attachment.isNew()) return;
        const result = await AppUtils.callService(() => attachmentService.getAttachment(id), false);
        if (!result) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, result));
    };

    handleAttachmentRemove = (id: string) => {
        if (Base.isNullOrEmpty(id)) return;
        const attachments = this.state.attachments.filter(i => i.id !== id);
        const photoAttachmentIds = this.state.photoAttachmentIds.filter(i => i !== id);
        const removedAttachmentIds = this.state.removedAttachmentIds.slice(0);
        removedAttachmentIds.push(id);
        this.setState({ attachments, photoAttachmentIds, removedAttachmentIds });
    };

    hasCameras = (): boolean => {
        return !Base.isNullOrUndefined(this.state.cameraIds) && this.state.cameraIds.length > 0;
    };

    handleAttachmentAddPhoto = (cameraEventAttachmentCategory: number) => {
        if (!this.hasCameras()) return;
        this.setState({ showCamera: true, cameraEventAttachmentCategory });
    };

    handleCameraStreamAvailable = () => {
        this.setState({ showingCamera: true });
    };

    private setScrollToClassNameByEventAttachmentCategory() {
        this.scrollToClassName = (EventAttachmentCategory.Basic === this.state.cameraEventAttachmentCategory ? "basic" : "action") + "Attachments";
    }

    handleCameraPhotoOk = (dataUrl: string) => {
        this.setScrollToClassNameByEventAttachmentCategory();
        if (Base.isNullOrEmpty(dataUrl)) {
            this.setState({ showCamera: false, showingCamera: false });
            return;
        }
        FileAttachment.photoToFileAttachment(dataUrl, this.state.cameraEventAttachmentCategory).then(attachment => {
            if (Base.isNullOrUndefined(attachment)) return;
            const attachments = this.state.attachments.slice(0);
            attachments.push(attachment);
            const photoAttachmentIds = this.state.photoAttachmentIds.slice(0);
            photoAttachmentIds.push(attachment.id);
            this.setState({ attachments, photoAttachmentIds, showCamera: false, showingCamera: false });
        });
    };

    handleCameraPhotoCancel = (permissionDenied: boolean) => {
        this.setScrollToClassNameByEventAttachmentCategory();
        if (!permissionDenied) {
            this.setState({ showCamera: false, showingCamera: false });
        } else {
            this.setState({ showCamera: false, showingCamera: false, cameraIds: [] });
        }
    };
    //#endregion

    //#region Phase 4: Identification
    handleEditEventEventTypes = (eventTypeIds: string[], eventTypeCategory: number) => {
        //console.log("handleEditEventEventTypes", eventTypeIds);
        if (!eventTypeIds || eventTypeIds.length < 1) return;
        const state = this.state;
        const eventEventTypes = state.eventEventTypes.slice(0);
        const savedEventEventTypeIds = state.savedEventEventTypeIds.slice(0);
        const currentEventEventTypes = state.eventEventTypes.filter(i => i.eventTypeCategory === eventTypeCategory);
        //console.log("currentEventTypeIds", eventTypeIds);
        //Add added
        for (let i = 0; i < eventTypeIds.length; i++) {
            const eventTypeId = eventTypeIds[i];
            if (currentEventEventTypes.findIndex(j => j.eventTypeId === eventTypeId) < 0) {
                const eventEventType = EventEventType.createEventEventType(eventTypeId, eventTypeCategory);
                eventEventTypes.push(eventEventType);
                savedEventEventTypeIds.push(eventEventType.id);
            }
        }
        //Remove removed
        for (let i = 0; i < currentEventEventTypes.length; i++) {
            const currentEventTypeId = currentEventEventTypes[i].eventTypeId;
            if (eventTypeIds.indexOf(currentEventTypeId) < 0) {
                const index = eventEventTypes.findIndex(j => j.eventTypeId === currentEventTypeId);
                if (index < 0) continue;
                eventEventTypes.splice(index, 1);
            }
        }
        if (eventTypeCategory === EventTypeCategory.A) {
            const removedEventEventTypeIds = this.state.removedEventEventTypeIds.slice(0);
            for (let i = 0; i < currentEventEventTypes.length; i++) {
                const currentEventEventType = currentEventEventTypes[i];
                if (eventTypeIds.findIndex(j => j === currentEventEventType.eventTypeId) < 0) {
                    removedEventEventTypeIds.push(currentEventEventType.id);
                }
            }
            this.setState({ eventEventTypes, removedEventEventTypeIds, savedEventEventTypeIds });
        } else if (eventTypeCategory === EventTypeCategory.B) {
            const removedEventEventTypeBIds = this.state.removedEventEventTypeBIds.slice(0);
            for (let i = 0; i < currentEventEventTypes.length; i++) {
                const currentEventEventType = currentEventEventTypes[i];
                if (eventTypeIds.findIndex(j => j === currentEventEventType.eventTypeId) < 0) {
                    removedEventEventTypeBIds.push(currentEventEventType.id);
                }
            }
            this.setState({ eventEventTypes, removedEventEventTypeBIds, savedEventEventTypeIds });
        } else if (eventTypeCategory === EventTypeCategory.C) {
            const removedEventEventTypeCIds = this.state.removedEventEventTypeCIds.slice(0);
            for (let i = 0; i < currentEventEventTypes.length; i++) {
                const currentEventEventType = currentEventEventTypes[i];
                if (eventTypeIds.findIndex(j => j === currentEventEventType.eventTypeId) < 0) {
                    removedEventEventTypeCIds.push(currentEventEventType.id);
                }
            }
            this.setState({ eventEventTypes, removedEventEventTypeCIds, savedEventEventTypeIds });
        }
    };
    //#endregion

    //Phase 5: Followup
    handleAddEventHandlers = (users: IUserListItem[]) => {
        if (!users || users.length < 1) return;
        const eventHandlers = this.state.eventHandlers.slice(0);
        const savedEventHandlerIds = this.state.savedEventHandlerIds.slice(0);
        for (const user of users) {
            const eventHandler = EventHandler.createEventHandler(user.code, user.name, user.picture);
            eventHandlers.push(eventHandler);
            savedEventHandlerIds.push(eventHandler.id);
        }
        this.setState({
            eventHandlers: EventHandler.sortEventHandlers(eventHandlers, { currentUserCode: this.props.userCode }),
            savedEventHandlerIds
        });
    };

    handleRemoveEventHandler = (id: string) => {
        if (Base.isNullOrEmpty(id)) return;
        const eventHandler = this.state.eventHandlers.find(i => i.id === id);
        if (Base.isNullOrUndefined(eventHandler)) return;
        const removedEventHandlerIds = this.state.removedEventHandlerIds.slice(0);
        if (!eventHandler.isNew()) {
            removedEventHandlerIds.push(id);
        }
        this.setState({
            eventHandlers: this.state.eventHandlers.filter(i => i.id !== id),
            removedEventHandlerIds,
            savedEventHandlerIds: this.state.savedEventHandlerIds.filter(i => i !== id)
        });
    };

    setEventHandlerApproved = (eventHandler: IEventHandler, callback: () => void = null) => {
        const modEventHandler = new EventHandler(eventHandler);
        modEventHandler.approveDate = (new Date()).getTime();
        const savedEventHandlerIds = this.state.savedEventHandlerIds.slice(0);
        savedEventHandlerIds.push(modEventHandler.id);
        this.setState({
            eventHandlers: this.state.eventHandlers.map(i => { return i.id === eventHandler.id ? modEventHandler : i; }),
            savedEventHandlerIds
        }, callback);
    };

    handleApproveEventHandler = async () => {
        const eventHandler = this.state.eventHandlers.find(i => i.userCode === this.props.userCode);
        if (!eventHandler) return;
        if (!this.state.immediateAction) {
            const result = await AppUtils.showConfirmationDialog(Translations.ApproveEventHandlerConfirmation, false, storeTypes.ConfirmationDialogType.Information, Translations.ApproveEvent);
            if (result !== ConfirmationDialogResult.Yes) return;
        }
        this.setEventHandlerApproved(eventHandler);
    };

    saveEventHandlerLockedApproved = async (eventHandler: IEventHandler) => {
        const obj = this;
        const saveData = new SaveDataObj();
        saveData.append("eventId", this.state.id);
        //Call server
        const result = await AppUtils.callService(() => eventService.approveEvent(saveData.obj));
        if (!result) return null;
        obj.setEventHandlerApproved(eventHandler, () => {
            EventEdit.getSaveDataFromState(obj.props, obj.state, true, false)
                .then(saveData => {
                    EventEdit.orgStateHash = saveData.getHash(EventEdit.hashIgnoreSaveDataFields);
                });
        });
    };

    handleApproveEventHandlerLocked = async () => {
        const eventHandler = this.state.eventHandlers.find(i => i.userCode === this.props.userCode);
        if (!eventHandler) return;
        if (!this.state.immediateAction) {
            const result = await AppUtils.showConfirmationDialog(Translations.ApproveEventHandlerConfirmation, false, storeTypes.ConfirmationDialogType.Information, Translations.ApproveEvent);
            if (result !== ConfirmationDialogResult.Yes) return;
        }
        this.saveEventHandlerLockedApproved(eventHandler);
    };
    //#endregion

    //Phase 7: Messages (USED ONLY IN EDIT MODE)
    handleAddEventMessage = (message: string) => {
        if (Base.isNullOrEmpty(message)) return;
        const eventMessages = this.state.eventMessages.slice(0);
        const eventMessage = new EventMessage();
        eventMessage.id = Base.getGuid();
        eventMessage.text = message;
        eventMessage.modifyDate = new Date().getTime();
        eventMessage.modifyUserCode = this.props.userCode;
        eventMessage.name = this.props.userName;
        eventMessage.picture = this.props.userPicture;
        eventMessages.unshift(eventMessage);
        this.setState({ eventMessages });
    };
    //#endregion

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.Event}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        const isNewEvent = this.isNewEvent();
        const userIsIsSystemAdmin = state.userIsIsSystemAdmin;
        const canHandleEvent = this.canHandleEvent();
        const canEditIdentificationData = this.canEditIdentificationData();
        let companyName = "";
        let company = props.companies.find(i => i.id === state.companyId);
        if (Base.isNullOrUndefined(company) && props.companies.length > 0) {
            company = props.companies[0];
        }
        if (!Base.isNullOrUndefined(company)) {
            companyName = company.name;
        }
        const isPublished = !Base.isNullOrUndefined(item.publishDate);
        const firstApproveAndClosedDate = item.getFirstAndLastEventHandlerApproveDate();
        const isClosed = !Base.isNullOrUndefined(firstApproveAndClosedDate.closedDate);
        const approveDate = firstApproveAndClosedDate.closedDate;
        const hasBeenApproved = !Base.isNullOrUndefined(firstApproveAndClosedDate.firstApprovedDate);
        const userIsCreator = this.userIsCreator();
        const isLockedToOtherUser = this.isLockedToOtherUser(props.userCode);
        const orgAttachments: IFileAttachment[] = state.attachments.filter(i => i.category === EventAttachmentCategory.Basic);
        const newAttachments: IFileAttachment[] = state.attachments.filter(i => i.category !== EventAttachmentCategory.Basic);
        const eventEventTypeBs = state.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.B);
        const eventEventTypeCs = state.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.C);
        const showCamera = this.hasCameras() && state.showCamera;
        const showingCamera = showCamera && state.showingCamera;
        const sourceCompanyIsTargetCompany = props.createCompany.id === state.companyId;
        const userCompanyIsReceivingCompany = props.userCompanyId === state.companyId;
        const canSelectReceiver = isNewEvent && (props.companies.length > 1 || props.units.length > 1);
        //Basic information permissions
        const basicInformationIsEditable = !isLockedToOtherUser && (isNewEvent || (!hasBeenApproved && (userIsCreator || userIsIsSystemAdmin)));
        const basicInformationUrgencyClassIsEditable = !isLockedToOtherUser && userCompanyIsReceivingCompany && (isNewEvent || !isPublished || (!hasBeenApproved && userIsCreator) || (!isClosed && canHandleEvent));
        const basicInformationUnitIsEditable = !isNewEvent && props.units.length > 1 && (!isPublished || canEditIdentificationData);
        const basicInformationAttachmentsAreEditable = userIsCreator || userIsIsSystemAdmin;
        //Actions permissions
        const actionsAndRootCauseAreEditable = !isLockedToOtherUser && !isClosed && canHandleEvent;
        const actionsAttachmentsAreEditable = canHandleEvent;
        const handlersAreEditable = !isLockedToOtherUser && !isClosed && canHandleEvent;
        const messagesAreEditable = userIsCreator || canHandleEvent;
        //Identification permissions
        const identificationDataIsEditable = !isLockedToOtherUser && canEditIdentificationData;
        const selectableEventTypeNodes = isNewEvent && !canHandleEvent && !canEditIdentificationData ? this.getSelectableEventTypeNodes() : [];
        const selectableEventTypeBNodes = isNewEvent && !canHandleEvent && !canEditIdentificationData ? this.getSelectableEventTypeBNodes() : [];
        const selectableEventTypeCNodes = isNewEvent && !canHandleEvent && !canEditIdentificationData ? this.getSelectableEventTypeCNodes() : [];
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                {!showingCamera &&
                    <React.Fragment>
                        <EditPageHeader
                            title={Translations.Event + " - " + (this.isNewEvent() ? Translations.ANew : item.code)}
                            onBackClick={this.handleBackClick}
                        />
                        <Footer
                            isReadOnly={isLockedToOtherUser}
                            buttonTitle={!isPublished ? Translations.SaveAndSend : Translations.Save}
                            onClick={this.handleSaveClick}
                        />
                    </React.Fragment>
                }
                {!showingCamera &&
                    <div className="pageContentContainer mainEdit eventEdit">
                        <div className="dataContainer" ref={(elem) => { this.dataContainerDiv = elem; }} >
                            {/* Phase 2: Basic information, Attachments */ }
                            {!(isNewEvent && !canHandleEvent && !canEditIdentificationData) &&
                                <div className="sectionTitle">{Translations.Event}</div>
                            }
                            <LockedToOtherUser
                                isLockedToOtherUser={isLockedToOtherUser}
                                userIsIsSystemAdmin={props.userIsIsSystemAdmin}
                                lockedUserPicture={state.lockedUserPicture}
                                lockedUserName={state.lockedUserName}
                                onUnlockClick={this.handleUnlockClick}
                            />
                            {basicInformationIsEditable &&
                                <div>
                                    {(isNewEvent && !canHandleEvent && !canEditIdentificationData) &&
                                        <FormRow
                                        />
                                    }
                                    {canSelectReceiver &&
                                        <FormRow
                                            label={userCompanyIsReceivingCompany ? Translations.Unit : Translations.Receiver}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={this.handleSelectReceiverClick}
                                                />
                                            }
                                        >
                                            <div>{userCompanyIsReceivingCompany ? state.unitCode : companyName}</div>
                                        </FormRow>
                                    }
                                    {(!isNewEvent && !sourceCompanyIsTargetCompany && userCompanyIsReceivingCompany) &&
                                        <FormRow
                                            label={Translations.Sender}
                                        >
                                            <div>{props.createCompany.name}</div>
                                        </FormRow>
                                    }
                                    {(!isNewEvent && !sourceCompanyIsTargetCompany && !userCompanyIsReceivingCompany) &&
                                        <FormRow
                                            label={Translations.Receiver}
                                        >
                                            <div>{companyName}</div>
                                        </FormRow>
                                    }
                                    {!(canSelectReceiver && userCompanyIsReceivingCompany) &&
                                        <FormRow
                                            label={Translations.Unit}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={canSelectReceiver ? this.handleSelectReceiverClick : this.handleSelectUnitClick}
                                                />
                                            }
                                        >
                                            <div>{userCompanyIsReceivingCompany ? state.unitCode : state.createCompanyUnitCode}</div>
                                        </FormRow>
                                    }
                                    {(!isNewEvent || userCompanyIsReceivingCompany) &&
                                        <FormRow
                                            label={Translations.EventUrgencyClass}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={this.handleChangeUrgencyClassClick}
                                                />
                                            }
                                        >
                                            <div><EventEditUrgencyClassStateText urgencyClass={props.urgencyClasses.find(i => i.id === state.urgencyClassId)} wide={true} /></div>
                                        </FormRow>
                                    }
                                    {isNewEvent && !canHandleEvent && !canEditIdentificationData && selectableEventTypeNodes.length > 0 &&
                                        <FormRow
                                            label={Translations.EventType}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={this.handleChangeNewEventTypeClick}
                                                />
                                            }
                                        >
                                            <div>{EventTypeNode.getPathNamesString(selectableEventTypeNodes, EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.A), `'${Translations.NotSelected}'`)}</div>
                                        </FormRow>
                                    }
                                    {isNewEvent && !canHandleEvent && !canEditIdentificationData && selectableEventTypeBNodes.length > 0 &&
                                        <FormRow
                                            label={Translations.EventTypeB}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={this.handleChangeNewEventTypeBClick}
                                                />
                                            }
                                        >
                                            <div>{EventTypeNode.getPathNamesString(selectableEventTypeBNodes, EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.B), `'${Translations.NotSelected}'`)}</div>
                                        </FormRow>
                                    }
                                    {isNewEvent && !canHandleEvent && !canEditIdentificationData && selectableEventTypeCNodes.length > 0 &&
                                        <FormRow
                                            label={Translations.EventTypeC}
                                            changeButton={
                                                <ToolButton
                                                    tooltip={Translations.Change}
                                                    classes="edit round mono smaller right"
                                                    onClick={this.handleChangeNewEventTypeCClick}
                                                />
                                            }
                                        >
                                            <div>{EventTypeNode.getPathNamesString(selectableEventTypeCNodes, EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.C), `'${Translations.NotSelected}'`)}</div>
                                        </FormRow>
                                    }
                                    <div className="row">
                                        <div className="col-6">
                                            <FormGroup
                                                label={Translations.Date}
                                                required={true}
                                            >
                                                <Datetime
                                                    locale={appConfig.culture}
                                                    className={"roWhite"}
                                                    value={state.date}
                                                    dateFormat={"D.M.YYYY"}
                                                    timeFormat={false}
                                                    closeOnSelect={true}
                                                    inputProps={{ maxLength: 10, readOnly: true, disabled: false, required: true }}
                                                    onChange={this.handleDateChange}
                                                    onBlur={this.handleDateBlur}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="col-6">
                                            <FormGroup
                                                label={Translations.Time}
                                                required={true}
                                            >
                                                <Datetime
                                                    locale={appConfig.culture}
                                                    className={"roWhite right"}
                                                    value={state.time}
                                                    dateFormat={false}
                                                    timeFormat={"H:mm"}
                                                    timeConstraints={ { minutes: { step: 5, min: 0, max: 59 } } }
                                                    input={true}
                                                    closeOnSelect={true}
                                                    inputProps={{ maxLength: 5, readOnly: true, disabled: false, required: true }}
                                                    onChange={this.handleTimeChange}
                                                    onBlur={this.handleTimeBlur}
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <FormRow
                                        label={Translations.Title}
                                        required={true}
                                    >
                                        <input className="form-control" type="text" name="name" title={Translations.Title} maxLength={50} readOnly={false} disabled={false} value={state.name} required={true} onChange={this.handleChange} />
                                    </FormRow>
                                    <FormRow
                                        label={Translations.Description}
                                        required={true}
                                    >
                                        <textarea className="form-control medium" name="description" title={Translations.Description} readOnly={false} disabled={false} value={state.description} required={true} onChange={this.handleChange} />
                                    </FormRow>
                                    <FormRow
                                        label={Translations.Observer}
                                    >
                                        <input className="form-control" type="text" name="observer" title={Translations.Observer} maxLength={100} readOnly={false} disabled={false} value={state.observer} onChange={this.handleChange} />
                                    </FormRow>
                                    {!!state.eventSetting?.observerActionIsInUse() &&
                                        <FormRow
                                            label={Translations.ObserverAction}
                                            required={state.eventSetting?.observerActionIsRequired()}
                                        >
                                            <textarea className="form-control medium" name="observerAction" title={Translations.ObserverAction} readOnly={false} disabled={false} value={state.observerAction} required={state.eventSetting?.observerActionIsRequired()} onChange={this.handleChange} />
                                        </FormRow>
                                    }
                                    <div className="row basicAttachments">
                                        <div className="col-12">
                                            <AttachmentList
                                                isReadOnly={!basicInformationAttachmentsAreEditable}
                                                canShowCamera={this.hasCameras()}
                                                lateThreshold={firstApproveAndClosedDate.firstApprovedDate}
                                                attachments={orgAttachments}
                                                onDownloadAttachment={this.handleAttachmentDownload}
                                                onRemoveAttachment={this.handleAttachmentRemove}
                                                onAddAttachments={(fileList: FileList) => this.handleAttachmentAdd(fileList, EventAttachmentCategory.Basic) }
                                                onAddPhoto={() => this.handleAttachmentAddPhoto(EventAttachmentCategory.Basic)}
                                            />
                                        </div>
                                    </div>
                                    {!!state.eventSetting?.locationIsInUse() && (isNewEvent || !!state.locationName) &&
                                        <FormRow
                                            label={Translations.Location}
                                        >
                                            {(state.positionErrorCode === -1) &&
                                                <div>{Translations.DetectingLocation}</div>
                                            }
                                            {(state.positionErrorCode === 0) &&
                                                <div className="locationLink" onClick={ () => { Base.openLocationInMaps(state.latitude, state.longitude); } }>{!Base.isNullOrEmpty(state.locationName) ? state.locationName : (state.latitude.toLocaleFixed(6) + ", " + state.longitude.toLocaleFixed(6))}</div>
                                            }
                                            {(state.positionErrorCode === 1) &&
                                                <div className="errorText">{Translations.PositionErrorPermissionDenied}</div>
                                            }
                                            {(state.positionErrorCode === 2) &&
                                                <div className="errorText">{Translations.PositionErrorUnavailable}</div>
                                            }
                                            {(state.positionErrorCode === 3) &&
                                                <div className="errorText">{Translations.PositionErrorTimeout}</div>
                                            }
                                        </FormRow>
                                    }
                                </div>
                            }
                            {!basicInformationIsEditable &&
                                <EventEditBasicInformationSummary
                                    userCompanyIsReceivingCompany={userCompanyIsReceivingCompany}
                                    sourceCompanyIsTargetCompany={sourceCompanyIsTargetCompany}
                                    urgencyClassIsEditable={basicInformationUrgencyClassIsEditable}
                                    urgencyClasses={props.urgencyClasses}
                                    eventSetting={state.eventSetting}
                                    createCompanyName={props.createCompany.name}
                                    companyName={companyName}
                                    unitName={userCompanyIsReceivingCompany ? state.unitCode : state.createCompanyUnitCode}
                                    urgencyClassId={state.urgencyClassId}
                                    code={state.code}
                                    date={state.date}
                                    time={state.time}
                                    name={state.name}
                                    observer={state.observer}
                                    observerAction={state.observerAction}
                                    description={state.description}
                                    latitude={state.latitude}
                                    longitude={state.longitude}
                                    locationName={state.locationName}
                                    lateThreshold={firstApproveAndClosedDate.firstApprovedDate}
                                    attachments={orgAttachments}
                                    onDownloadAttachment={this.handleAttachmentDownload}
                                    userIsCreator={userIsCreator}
                                    userIsIsSystemAdmin={userIsIsSystemAdmin}
                                    canSelectUnit={basicInformationUnitIsEditable}
                                    onSelectUnit={this.handleSelectUnitClick}
                                    onSelectUrgencyClass={this.handleChangeUrgencyClassClick}
                                    canShowCamera={this.hasCameras()}
                                    onRemoveAttachment={this.handleAttachmentRemove}
                                    onAddAttachments={(fileList: FileList) => this.handleAttachmentAdd(fileList, EventAttachmentCategory.Basic) }
                                    onAddPhoto={() => this.handleAttachmentAddPhoto(EventAttachmentCategory.Basic)}
                                />
                            }
                            {(!isNewEvent || canHandleEvent) &&
                                <div>
                                    {/* Phase 5: Actions */ }
                                    <div className="sectionTitle">{Translations.Actions}<div className={"btn " + (state.actionsVisible ? "collapseUp" : "expandDown")} onClick={() => { this.setState({ actionsVisible: !state.actionsVisible }); }}><span className="icon"></span></div></div>
                                    {(state.actionsVisible
                                        ? (actionsAndRootCauseAreEditable
                                            ? <div>
                                                <FormRow
                                                    label={Translations.ImmediateAction}
                                                >
                                                    <textarea className="form-control medium" name="immediateAction" title={Translations.ImmediateAction} readOnly={false} disabled={false} value={state.immediateAction} onChange={this.handleChange} />
                                                </FormRow>
                                                <FormRow
                                                    label={Translations.PreventiveAction}
                                                >
                                                    <textarea className="form-control medium" name="preventiveAction" title={Translations.PreventiveAction} readOnly={false} disabled={false} value={state.preventiveAction} onChange={this.handleChange} />
                                                </FormRow>
                                                <FormRow
                                                    label={Translations.RootCause}
                                                >
                                                    <textarea className="form-control medium" name="rootCause" title={Translations.RootCause} readOnly={false} disabled={false} value={state.rootCause} onChange={this.handleChange} />
                                                </FormRow>
                                                <div className="row actionAttachments">
                                                    <div className="col-12">
                                                        <AttachmentList
                                                            isReadOnly={!actionsAttachmentsAreEditable}
                                                            canShowCamera={this.hasCameras()}
                                                            lateThreshold={firstApproveAndClosedDate.closedDate}
                                                            attachments={newAttachments}
                                                            onDownloadAttachment={this.handleAttachmentDownload}
                                                            onRemoveAttachment={this.handleAttachmentRemove}
                                                            onAddAttachments={(fileList: FileList) => this.handleAttachmentAdd(fileList, EventAttachmentCategory.Action) }
                                                            onAddPhoto={() => this.handleAttachmentAddPhoto(EventAttachmentCategory.Action)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : <EventEditActionsSummary
                                                immediateAction={state.immediateAction}
                                                preventiveAction={state.preventiveAction}
                                                rootCause={state.rootCause}
                                                lateThreshold={firstApproveAndClosedDate.closedDate}
                                                attachments={newAttachments}
                                                onDownloadAttachment={this.handleAttachmentDownload}
                                                attachmentsAreEditable={actionsAttachmentsAreEditable}
                                                canShowCamera={this.hasCameras()}
                                                onRemoveAttachment={this.handleAttachmentRemove}
                                                onAddAttachments={(fileList: FileList) => this.handleAttachmentAdd(fileList, EventAttachmentCategory.Action) }
                                                onAddPhoto={() => this.handleAttachmentAddPhoto(EventAttachmentCategory.Action)}
                                            />
                                        )
                                        : null
                                    )}
                                    {/* Phase 4: Handlers */ }
                                    <div className="sectionTitle">{Translations.EventHandlers + " (" + state.eventHandlers.length + ")"}<div className={"btn " + (state.eventHandlersVisible ? "collapseUp" : "expandDown")} onClick={() => { this.setState({ eventHandlersVisible: !state.eventHandlersVisible }); }}><span className="icon"></span></div></div>
                                    {(state.eventHandlersVisible
                                        ? (handlersAreEditable
                                            ? <div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <EventHandlerList
                                                            isReadOnly={false}
                                                            isClosed={isClosed}
                                                            unitId={state.unitId}
                                                            userCode={props.userCode}
                                                            eventCreateUserCode={item.createUserCode}
                                                            eventHandlers={state.eventHandlers}
                                                            messages={[]}
                                                            onRemoveEventHandler={this.handleRemoveEventHandler}
                                                            onAddEventHandlers={this.handleAddEventHandlers}
                                                            onApproveEventHandler={this.handleApproveEventHandler}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : <EventEditEventHandlersSummary
                                                userCode={props.userCode}
                                                eventHandlers={state.eventHandlers}
                                                comment={state.comment}
                                                isClosed={isClosed}
                                                approveDate={approveDate}
                                                publishDate={item.publishDate}
                                                createDate={item.createDate}
                                                onApproveEventHandler={!isClosed && canHandleEvent ? this.handleApproveEventHandlerLocked : null}
                                            />
                                        )
                                        : null
                                    )}
                                    {/* Phase 6: Comments */ }
                                    <div className="sectionTitle">{Translations.Comments + " (" + state.eventMessages.filter(i => !i.publishIndicator && !i.approveIndicator && !i.closedIndicator).length + ")"}<div className={"btn " + (state.messagesVisible ? "collapseUp" : "expandDown")} onClick={() => { this.setState({ messagesVisible: !state.messagesVisible }); }}><span className="icon"></span></div></div>
                                    {state.messagesVisible &&
                                        <div>
                                            {isNewEvent &&
                                                <FormRow
                                                    label={Translations.Comment}
                                                    white={true}
                                                >
                                                    <textarea className="form-control medium" name="comment" title={Translations.Comment} maxLength={1000} readOnly={false} disabled={false} value={state.comment} onChange={this.handleChange} />
                                                </FormRow>
                                            }
                                            {!isNewEvent &&
                                                <div className="row">
                                                    <div className="col-12">
                                                        <EventMessageList
                                                            isReadOnly={!messagesAreEditable}
                                                            eventId={item.id}
                                                            userCode={props.userCode}
                                                            eventHandlers={state.eventHandlers}
                                                            messages={state.eventMessages}
                                                            onAddMessage={this.handleAddEventMessage}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {(isNewEvent || canEditIdentificationData) &&
                                <div>
                                    {/* Phase 7: Identification */ }
                                    <div className="sectionTitle">{Translations.Identification}<div className={"btn " + (state.identificationVisible ? "collapseUp" : "expandDown")} onClick={() => { this.setState({ identificationVisible: !state.identificationVisible }); }}><span className="icon"></span></div></div>
                                    {(state.identificationVisible
                                        ? (identificationDataIsEditable
                                            ? <div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <EventEventTypeList
                                                            isReadOnly={false}
                                                            title={Translations.EventTypes}
                                                            info={Translations.AddEventTypesToEvent}
                                                            selectTitle={Translations.EditEventTypes}
                                                            eventTypeCategory={EventTypeCategory.A}
                                                            eventEventTypes={state.eventEventTypes.filter(i => i.eventTypeCategory === EventTypeCategory.A)}
                                                            eventTypeNodes={props.eventTypeNodes}
                                                            onEditEventEventTypes={this.handleEditEventEventTypes}
                                                        />
                                                    </div>
                                                </div>
                                                {props.eventTypeBNodes.length > 0 &&
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <EventEventTypeList
                                                                isReadOnly={false}
                                                                title={Translations.EventTypeBs}
                                                                info={Translations.AddEventTypeBsToEvent}
                                                                selectTitle={Translations.EditEventTypeBs}
                                                                eventTypeCategory={EventTypeCategory.B}
                                                                eventEventTypes={eventEventTypeBs}
                                                                eventTypeNodes={props.eventTypeBNodes}
                                                                onEditEventEventTypes={this.handleEditEventEventTypes}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {props.eventTypeCNodes.length > 0 &&
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <EventEventTypeList
                                                                isReadOnly={false}
                                                                title={Translations.EventTypeCs}
                                                                info={Translations.AddEventTypeCsToEvent}
                                                                selectTitle={Translations.EditEventTypeCs}
                                                                eventTypeCategory={EventTypeCategory.C}
                                                                eventEventTypes={eventEventTypeCs}
                                                                eventTypeNodes={props.eventTypeCNodes}
                                                                onEditEventEventTypes={this.handleEditEventEventTypes}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                <FormRow
                                                    label={Translations.DirectCosts}
                                                >
                                                    <input className="form-control disabled" type="text" name="directCosts" title={Translations.DirectCosts} maxLength={10} readOnly={false} disabled={false} value={state.directCosts} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                </FormRow>
                                                <FormRow
                                                    label={Translations.IndirectCosts}
                                                >
                                                    <input className="form-control disabled" type="text" name="indirectCosts" title={Translations.IndirectCosts} maxLength={10} readOnly={false} disabled={false} value={state.indirectCosts} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                </FormRow>
                                                <FormRow
                                                    label={Translations.Amount}
                                                >
                                                    <input className="form-control disabled" type="text" name="amount" title={Translations.Amount} maxLength={10} readOnly={false} disabled={false} value={state.amount} onChange={this.handleChange} onBlur={this.handleBlur} />
                                                </FormRow>
                                                <FormRow
                                                    label={Translations.IdentificationDetails}
                                                >
                                                    <textarea className="form-control medium" name="identificationDetails" title={Translations.IdentificationDetails} maxLength={1000} readOnly={false} disabled={false} value={state.identificationDetails} onChange={this.handleChange} />
                                                </FormRow>
                                            </div>
                                            : <EventEditIdentificationSummary
                                                eventTypeNodes={props.eventTypeNodes}
                                                eventTypeBNodes={props.eventTypeBNodes}
                                                eventTypeCNodes={props.eventTypeCNodes}
                                                eventEventTypes={state.eventEventTypes}
                                                directCosts={state.directCosts.toDecimal(false, true)}
                                                indirectCosts={state.indirectCosts.toDecimal(false, true)}
                                                amount={state.amount.toDecimal(false, true)}
                                                identificationDetails={state.identificationDetails}
                                            />
                                        )
                                        : null
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                }
                {!showingCamera &&
                    <div className="toolbar">
                        {!isLockedToOtherUser &&
                            <div className="buttons">
                                <ToolButton
                                    classes="save mui"
                                    title={!isPublished ? Translations.SaveAndSend : Translations.Save}
                                    tooltip={!isPublished ? Translations.SaveAndSend : Translations.Save}
                                    onClick={this.handleSaveClick}
                                />
                            </div>
                        }
                    </div>
                }
                {!showingCamera &&
                    <div className="toolbar">
                        {(!isLockedToOtherUser && props.canSaveEvent) &&
                            <div className="buttons">
                                <ToolButton
                                    classes="save mui"
                                    title={!isPublished ? Translations.SaveAndSend : Translations.Save}
                                    tooltip={!isPublished ? Translations.SaveAndSend : Translations.Save}
                                    onClick={this.handleSaveClick}
                                />
                            </div>
                        }
                    </div>
                }
                {showCamera &&
                    <CameraPhoto
                        cameraIds={state.cameraIds}
                        cameraStreamAvailable={state.showingCamera}
                        onCameraStreamAvailable={this.handleCameraStreamAvailable}
                        onOkClick={this.handleCameraPhotoOk}
                        onCancelClick={this.handleCameraPhotoCancel}
                    />
                }
                {state.newEventWizardWindowIndex > -0.5 && state.newEventWizardWindows[state.newEventWizardWindowIndex] === NewEventWizardWindowType.Receiver &&
                    <SelectReceiverDialog
                        nextPreviousMode={true}
                        companies={this.props.companies}
                        units={this.props.units}
                        companyId={state.companyId}
                        unitId={state.unitId}
                        onOk={this.handleSelectReceiverWizardDialogNext}
                        onCancel={this.handleSelectEventTypeWizardDialogCancel}
                        onPrevious={state.newEventWizardWindowIndex > 0 ? this.handleSelectEventTypeWizardDialogPrevious : null}
                    />
                }
                {state.newEventWizardWindowIndex > -0.5 && state.newEventWizardWindows[state.newEventWizardWindowIndex] === NewEventWizardWindowType.EventType &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventType + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}
                        nextPreviousMode={true}
                        eventTypeNodes={this.getSelectableEventTypeNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.A)}
                        onOk={(ids: string[]) => { this.handleSelectEventTypeWizardDialogNext(ids, EventTypeCategory.A); }}
                        onCancel={this.handleSelectEventTypeWizardDialogCancel}
                        onPrevious={state.newEventWizardWindowIndex > 0 ? this.handleSelectEventTypeWizardDialogPrevious : null}
                    />
                }
                {state.newEventWizardWindowIndex > -0.5 && state.newEventWizardWindows[state.newEventWizardWindowIndex] === NewEventWizardWindowType.EventTypeB &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventTypeB + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}
                        nextPreviousMode={true}
                        eventTypeNodes={this.getSelectableEventTypeBNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.B)}
                        onOk={(ids: string[]) => { this.handleSelectEventTypeWizardDialogNext(ids, EventTypeCategory.B); }}
                        onCancel={this.handleSelectEventTypeWizardDialogCancel}
                        onPrevious={state.newEventWizardWindowIndex > 0 ? this.handleSelectEventTypeWizardDialogPrevious : null}
                    />
                }
                {state.newEventWizardWindowIndex > -0.5 && state.newEventWizardWindows[state.newEventWizardWindowIndex] === NewEventWizardWindowType.EventTypeC &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventTypeC + " (" + Translations.Voluntary.toLocaleLowerCase() + ")"}
                        nextPreviousMode={true}
                        eventTypeNodes={this.getSelectableEventTypeCNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.C)}
                        onOk={(ids: string[]) => { this.handleSelectEventTypeWizardDialogNext(ids, EventTypeCategory.C); }}
                        onCancel={this.handleSelectEventTypeWizardDialogCancel}
                        onPrevious={state.newEventWizardWindowIndex > 0 ? this.handleSelectEventTypeWizardDialogPrevious : null}
                    />
                }
                {state.showSelectReceiverDialog &&
                    <SelectReceiverDialog
                        companies={this.props.companies}
                        units={this.props.units}
                        companyId={state.companyId}
                        unitId={state.unitId}
                        onOk={this.handleSelectReceiverDialogOk}
                        onCancel={this.handleSelectReceiverDialogCancel}
                    />
                }
                {state.showSelectUnitDialog &&
                    <SelectUnitDialog
                        title={Translations.SelectUnit}
                        selectedId={state.unitId}
                        companyLogo={this.companyLogo}
                        loadUnits={this.handleLoadUnits}
                        onOk={this.handleSelectUnitDialogOk}
                        onCancel={this.handleSelectUnitDialogCancel}
                    />
                }
                {state.showSelectUrgencyClassDialog &&
                    <SelectUrgencyClassDialog
                        urgencyClasses={props.urgencyClasses}
                        urgencyClassId={state.urgencyClassId}
                        onOk={this.handleSelectUrgencyClassDialogOk}
                        onCancel={this.handleSelectUrgencyClassDialogCancel}
                    />
                }
                {state.showSelectEventTypeDialog &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventType}
                        eventTypeNodes={this.getSelectableEventTypeNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.A)}
                        onOk={this.handleSelectEventTypeDialogOk}
                        onCancel={this.handleSelectEventTypeDialogCancel}
                    />
                }
                {state.showSelectEventTypeBDialog &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventTypeB}
                        eventTypeNodes={this.getSelectableEventTypeBNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.B)}
                        onOk={this.handleSelectEventTypeBDialogOk}
                        onCancel={this.handleSelectEventTypeBDialogCancel}
                    />
                }
                {state.showSelectEventTypeCDialog &&
                    <SelectEventTypesDialog
                        title={Translations.SelectEventTypeC}
                        eventTypeNodes={this.getSelectableEventTypeCNodes()}
                        checkedIds={EventEventType.getEventTypeIds(state.eventEventTypes, EventTypeCategory.C)}
                        onOk={this.handleSelectEventTypeCDialogOk}
                        onCancel={this.handleSelectEventTypeCDialogCancel}
                    />
                }
            </div>
        );
    }
}